<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { RouterView } from 'vue-router';
import { useUiStore } from '@/stores/ui';
import ToastContainer from '@/components/ui/ToastContainer.vue';
import IframeModal from '@/components/ui/IframeModal.vue';
import IframeTaskbar from '@/components/ui/IframeTaskbar.vue';

const uiStore = useUiStore();

onMounted(() => {
  uiStore.initDarkMode();
  uiStore.initSidebar();
  uiStore.setupKeyboardShortcuts();
});

onUnmounted(() => {
  uiStore.cleanupKeyboardShortcuts();
});
</script>

<template>
  <div class="min-h-screen bg-gray-50 dark:bg-dark-900">
    <RouterView />
    <ToastContainer />
    <IframeModal />
    <IframeTaskbar />
  </div>
</template>
